import React from "react";
import { Box, Paper, Typography, useTheme, alpha } from "@mui/material";
import { InfoOutlined, Schedule } from "@mui/icons-material";

export const NoBookedLeadsWarning: React.FC = () => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        mb: 3,
        p: 0,
        borderRadius: 3,
        overflow: "hidden",
        border: `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
        background: `linear-gradient(135deg, ${alpha(
          theme.palette.primary.main,
          0.03
        )} 0%, ${alpha(theme.palette.primary.light, 0.08)} 100%)`,
        position: "relative",
      }}
    >
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: "flex", gap: 2.5, alignItems: "flex-start" }}>
          {/* Icon */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 48,
              height: 48,
              borderRadius: 2,
              background: `linear-gradient(135deg, ${
                theme.palette.primary.main
              } 0%, ${alpha(theme.palette.primary.main, 0.85)} 100%)`,
              boxShadow: `0 4px 12px ${alpha(
                theme.palette.primary.main,
                0.25
              )}`,
              flexShrink: 0,
            }}
          >
            <InfoOutlined
              sx={{
                color: "#ffffff",
                fontSize: 24,
              }}
            />
          </Box>

          {/* Content */}
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                color: theme.palette.primary.main,
                mb: 0.75,
                fontSize: "1.1rem",
              }}
            >
              No Booked Leads Found
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                mb: 2.5,
                lineHeight: 1.7,
              }}
            >
              Currently, there are no booked leads available in the system to
              generate upselling opportunities. Please check back later or
              create new leads to get started.
            </Typography>

            {/* Sync Info Box */}
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 1.5,
                p: 2,
                borderRadius: 2,
                bgcolor: alpha(theme.palette.primary.main, 0.06),
                border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 32,
                  height: 32,
                  borderRadius: 1,
                  bgcolor: alpha(theme.palette.primary.main, 0.1),
                  flexShrink: 0,
                }}
              >
                <Schedule
                  sx={{
                    color: theme.palette.primary.main,
                    fontSize: 18,
                  }}
                />
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  fontWeight={600}
                  sx={{
                    color: theme.palette.primary.main,
                    mb: 0.5,
                  }}
                >
                  Automated Data Sync
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: "text.secondary",
                    lineHeight: 1.6,
                    display: "block",
                  }}
                >
                  We fetch upselling opportunities daily around{" "}
                  <Box
                    component="span"
                    sx={{
                      color: theme.palette.primary.main,
                      fontWeight: 600,
                    }}
                  >
                    12:00 PM
                  </Box>
                  , and those opportunities will be available for the next{" "}
                  <Box
                    component="span"
                    sx={{
                      color: theme.palette.primary.main,
                      fontWeight: 600,
                    }}
                  >
                    24 hours
                  </Box>{" "}
                  after fetching.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

